// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__cVc8w","rating__star":"Rating_rating__star__yn0wf","rating__star--empty":"Rating_rating__star--empty__P6mpP"};